const CATEGORY_SECTION_SELECTOR = '[id$="__dd_categories"]';
const SAFE_ZONE_CLASS = 'dd-category-widget-safe-zone';

let categoryObserver;

function watchCategorySection() {
  categoryObserver?.disconnect();
  document.body?.classList.remove(SAFE_ZONE_CLASS);

  const categorySection = document.querySelector(CATEGORY_SECTION_SELECTOR);
  if (!categorySection || !document.body) return;

  categoryObserver = new IntersectionObserver(([entry]) => {
    document.body.classList.toggle(SAFE_ZONE_CLASS, entry?.isIntersecting === true);
  });
  categoryObserver.observe(categorySection);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', watchCategorySection, { once: true });
} else {
  watchCategorySection();
}

document.addEventListener('shopify:section:load', watchCategorySection);
document.addEventListener('shopify:section:unload', () => queueMicrotask(watchCategorySection));
